import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { FiCalendar, FiArrowRight } from "react-icons/fi";
import SEO from "../components/SEO";

export default function News() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function load() {
            try {
                // Remove complex query to avoid missing index errors
                const snap = await getDocs(collection(db, "blog"));
                const allPosts = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                
                // Filter and Sort in memory
                const filtered = allPosts
                    .filter(p => p.published === true)
                    .sort((a, b) => {
                        const dateA = a.date ? new Date(a.date + "T00:00:00") : (a.createdAt?.toDate ? a.createdAt.toDate() : new Date(0));
                        const dateB = b.date ? new Date(b.date + "T00:00:00") : (b.createdAt?.toDate ? b.createdAt.toDate() : new Date(0));
                        return dateB - dateA;
                    });

                setPosts(filtered);
            } catch (e) {
                console.error("Error loading blog:", e);
            }
            setLoading(false);
        }
        load();
    }, []);

    if (loading) return (
        <div className="container" style={{ padding: "100px 20px", textAlign: "center", color: "#888" }}>
            Loading the latest news...
        </div>
    );

    return (
        <div className="news-page">
            <SEO pageId="blog" />
            {/* Header */}
            <div style={{ background: "#fdf8e6", padding: "80px 0", textAlign: "center", marginBottom: 60 }}>
                <div className="container">
                    <h1 style={{ fontSize: "3.5rem", fontFamily: "'Playfair Display', serif", marginBottom: 16 }}>Latest News</h1>
                    <p style={{ fontSize: "1.1rem", color: "#666", maxWidth: 600, margin: "0 auto" }}>
                        Stay up to date with new releases, book signings, and stories from behind the scenes.
                    </p>
                </div>
            </div>

            <div className="container" style={{ paddingBottom: 100 }}>
                {posts.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "60px 0" }}>
                        <p style={{ color: "#888" }}>No news posts found. Check back soon!</p>
                    </div>
                ) : (
                    <div className="news-grid">
                        {posts.map(post => (
                            <Link key={post.id} to={`/news/${post.id}`} className="news-card">
                                <div className="news-card-img">
                                    <img src={post.imageUrl || "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&q=80&w=800"} alt={post.title} />
                                </div>
                                <div className="news-card-content">
                                    <div style={{ display: "flex", alignItems: "center", gap: 8, color: "var(--accent)", fontSize: 13, fontWeight: 700, marginBottom: 12, textTransform: "uppercase" }}>
                                        <FiCalendar size={14} />
                                        {post.date ? new Date(post.date + "T00:00:00").toLocaleDateString() : (post.createdAt?.toDate ? post.createdAt.toDate().toLocaleDateString() : "Recent")}
                                    </div>
                                    <h3 style={{ fontSize: "1.4rem", fontFamily: "'Playfair Display', serif", marginBottom: 12, color: "var(--green-primary)" }}>{post.title}</h3>
                                    <p style={{ color: "#666", fontSize: 15, lineHeight: 1.6, marginBottom: 20 }}>
                                        {post.excerpt || (post.content ? post.content.replace(/<[^>]*>/g, '').substring(0, 120) + "..." : "Read more about this update...")}
                                    </p>
                                    <div style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 700, color: "var(--accent)", fontSize: 14 }}>
                                        Read Full Story <FiArrowRight size={16} />
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>

            <style>{`
                .news-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
                    gap: 40px;
                }
                .news-card {
                    display: block;
                    text-decoration: none;
                    background: white;
                    border-radius: 16px;
                    overflow: hidden;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
                    transition: all 0.3s;
                    border: 1px solid #f0f0f0;
                }
                .news-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 12px 30px rgba(0,0,0,0.12);
                }
                .news-card-img {
                    height: 240px;
                    overflow: hidden;
                }
                .news-card-img img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.5s;
                }
                .news-card:hover .news-card-img img {
                    transform: scale(1.05);
                }
                .news-card-content {
                    padding: 28px;
                }
                @media (max-width: 600px) {
                    .news-grid { grid-template-columns: 1fr; }
                }
            `}</style>
        </div>
    );
}
